import request from '@/request'

// 获取当前用户信息
export function getCurrentUser() {
  return request({
    url: `/user/getCurrentUser`,
    method: 'get'
  })
}

// 根据用户ID查询用户资料
export function getUserInfo(userId, typeCode) {
  return request({
    url: `/user/info?userId=${userId}&typeCode=${typeCode}`,
    method: 'get'
  })
}

// 根据用户ID查询用户资料
export function getMyProfileById(userId) {
  return request({
    url: `/user/getMyProfileById?userId=${userId}`,
    method: 'get'
  })
}

// 发送验证码
export function sendVC(email) {
  return request({
    url: `/user/sendVC?toMail=${email}`,
    method: 'get'
  })
}

// 查询邮箱是否已注册
export function checkEmailIsExist(email) {
  return request({
    url: `/user/checkEmailIsExist?email=${email}`,
    method: 'get'
  })
}

// 查询手机是否已注册
export function checkPhoneIsExist(phone) {
  return request({
    url: `/user/checkPhoneIsExist?phone=${phone}`,
    method: 'get'
  })
}

// 校验验证码
export function checkVerificationCode(email, verificationCode) {
  return request({
    url: `/user/checkVerificationCode?email=${email}&verificationCode=${verificationCode}`,
    method: 'get'
  })
}

// 根据值查询用户(找回密码)
export function selectUserByEmail(email) {
  return request({
    url: `/user/selectUserByEmail?email=${email}`,
    method: 'get'
  })
}

// 根据值查询用户(找回密码)
export function selectUserByEmailOrAccountOrPhone(value) {
  return request({
    url: `/user/selectUserByEmailOrAccountOrPhone?value=${value}`,
    method: 'get'
  })
}

// 找回密码 - 修改密码
export function updatePass(updatePassDto) {
  return request({
    url: `/user/updatePass`,
    method: 'post',
    data: updatePassDto
  })
}

// 修改用户信息
export function updateData(updateDataFrom) {
  return request({
    url: `/user/updateData`,
    method: 'post',
    data: updateDataFrom
  })
}

// 检查当前账号是否官方账号
export function checkOfficialUser() {
  return request({
    url: `/user/checkOfficialUser`,
    method: 'get'
  })
}

// 根据条件查询系统消息接收人
export function selectSysMsgReceiver(receiverDto) {
  return request({
    url: `/user/selectSysMsgReceiver`,
    method: 'post',
    data: receiverDto
  })
}

// 用户总量
export function getUserCount() {
  return request({
    url: `/user/getUserCount`,
    method: 'get'
  })
}

// 获取本月注册的用户数量
export function getThisMonthRegisteredUserCount() {
  return request({
    url: `/user/getThisMonthRegisteredUserCount`,
    method: 'get'
  })
}

// 获取活跃用户数量
export function getActiveUsersCount() {
  return request({
    url: `/user/getActiveUsersCount`,
    method: 'get'
  })
}

// 获取二次访问数量
export function getVisitsMoreCount() {
  return request({
    url: `/user/getVisitsMoreCount`,
    method: 'get'
  })
}

// 
export function findAnalystLikeNameOrEmail(value) {
  return request({
    url: `/user/findAnalystLikeNameOrEmail?value=${value}`,
    method: 'get'
  })
}

export function updateUserType(typeCode) {
  return request({
    url: `/user/updateUserType?userTypeCode=${typeCode}`,
    method: 'get'
  })
}

export function getUserByKey(key) {
  return request({
    url: `/user/getUserByKey?key=${key}`,
    method: 'get'
  })
}

// 找回密码
export function updatePasswordByKey(updatePassDto) {
  return request({
    url: `/user/updatePasswordByKey`,
    method: 'post',
    data: updatePassDto
  })
}

// 修改密码
export function updatePasswordByCode(updatePassDto) {
  return request({
    url: `/user/updatePasswordByCode`,
    method: 'post',
    data: updatePassDto
  })
}

export function checkRetrievePasswordCodeByUserIdAndType(userId, code, type) {
  return request({
    url: `/user/checkRetrievePasswordCodeByUserIdAndType?userId=${userId}&code=${code}&type=${type}`,
    method: 'get'
  })
}

export function updatePassFromRetrievePassword(updatePassDto) {
  return request({
    url: `/user/updatePassFromRetrievePassword`,
    method: 'post',
    data: updatePassDto
  })
}

export function getUserAccountSecurityData() {
  return request({
    url: `/user/getUserAccountSecurityData`,
    method: 'get'
  })
}

export function updateAccount(account) {
  return request({
    url: `/user/updateAccount?account=${account}`,
    method: 'get'
  })
}

export function updateNickName(nickname,dialCode,phone,email) {
  return request({
    url: `/user/updateNickName?nickname=${nickname}&dialCode=${dialCode}&phone=${phone}&email=${email}`,
    method: 'get'
  })
}

export function getUserNickNameSecurityData(roleCode) {
  return request({
    url: `/user/getUserNickNameSecurityData?roleCode=${roleCode}`,
    method: 'get'
  })
}

export function bindEmail(email, code) {
  return request({
    url: `/user/bindEmail?email=${email}&code=${code}`,
    method: 'get'
  })
}

export function bindPhone(dialCode, phone, code) {
  return request({
    url: `/user/bindPhone?dialCode=${dialCode}&phone=${phone}&code=${code}`,
    method: 'get'
  })
}

export function getHisProfileByUserId(userId) {
  return request({
    url: `/user/getHisProfileByUserId?userId=${userId}`,
    method: 'get'
  })
}

export function getHisProfileByNickname(nickname) {
  return request({
    url: `/user/getHisProfileByNickname?nickname=${nickname}`,
    method: 'get'
  })
}

export function getMoney() {
  return request({
    url: `/user/getMoney`,
    method: 'get'
  })
}

export function getAnaByPage(dto) {
  return request({
    url: `/common/getAnaByPage`,
    method: 'post', 
    data: dto
  })
}

export function searchBidProjectByPage(obj) {
  return request({
    url: `/project/searchBidProjectByPage`,
    method: 'post', 
    data: obj
  })
}

export function uploadAvatar(obj) {
  return request({
    url: `/user/uploadAvatarUrl?userId=${obj.uid}`,
    method: 'post', 
    data: obj.avatar
  })
}

export function checkout(nickName,dialCode,phone,code,codeType,email) {
  return request({
    url: `/user/checkout?nickName=${nickName}&dialCode=${dialCode}&phone=${phone}&code=${code}&codeType=${codeType}&email=${email}`,
    method: 'get'
  })
}

//查询用户详情
export function getUserDetail(usid) {
  return request({
    url: `/admin/getUserDetail?usid=${usid}`,
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/user.js